const ACCEPTED_FILE_TYPES = ['.jpg', '.jpeg', '.png', '.pdf'];
const MAX_FILE_SIZE_MB = 8;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_FILES = 5;

type FileValidationResult = {
  isValid: boolean;
  error?: string;
};

/**
 * Validates a file against the accepted types and size limits
 * @param file - File to validate
 * @returns Validation result with error message if invalid
 */
function validateFile(file: File): FileValidationResult {
  const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}`;

  if (!ACCEPTED_FILE_TYPES.includes(fileExtension)) {
    return {
      isValid: false,
      error: 'validation.file_invalid_type',
    };
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      isValid: false,
      error: 'validation.file_too_large',
    };
  }

  return { isValid: true };
}

export { ACCEPTED_FILE_TYPES, MAX_FILES, MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB, validateFile };
